import React, { useState } from "react";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
import styles from "./index.module.css";

// Customizing icons for the toolbar (optional)
const icons = Quill.import("ui/icons");
icons["header"] = "Format"; // Custom name for headers
icons["bold"] = "B";
icons["italic"] = "I";
icons["strike"] = "S";
icons["link"] = "Link";
icons["list"] = "Lists";
icons["underline"] = "Line";
// icons["image"] = "Image";
icons["video"] = "Video";

// Custom toolbar component
const CustomToolbar = () => (
  <div id="toolbar">
    <span className="ql-formats">
      <select className="ql-header">
        <option value="">Format</option>
        <option value="1">Heading 1</option>
        <option value="2">Heading 2</option>
      </select>
    </span>
    <span className="ql-formats">
      <button className="ql-bold"></button>
      <button className="ql-italic"></button>
      <button className="ql-strike"></button>
      <button className="ql-underline"></button>
      <button className="ql-list"></button>
      <button className="ql-link"></button>
      {/* <button className="ql-image"></button> */}
      <button className="ql-video"></button>
    </span>
  </div>
);

const QuillEditor = ({
  onChange,
  value = "",
  label,
  id,
  required = false,
  maxLength = 500,
}) => {
  const [charCount, setCharCount] = useState(value.length || 0);

  const modules = {
    toolbar: {
      container: "#toolbar", // Custom toolbar
    },
  };

  const formats = [
    "header",
    "bold",
    "italic",
    "strike",
    "underline",
    "list",
    "link",
    // "image",
    "video",
  ];

  const handleChange = (content, delta, source, editor) => {
    const currentLength = editor.getText().trim().length;
    if (currentLength <= maxLength) {
      setCharCount(currentLength);
      onChange(content);
    } else {
      const trimmedContent = editor.getText().slice(0, maxLength);
      setCharCount(maxLength);
      onChange(trimmedContent);
    }
  };

  return (
    <div className={styles.formGroup}>
      <label htmlFor={id}>
        {label} {required && <span className="required">*</span>}
      </label>
      <CustomToolbar />
      <ReactQuill
        required
        style={{ minHeight: "200px" }}
        theme="snow"
        modules={modules}
        formats={formats}
        value={value || ""}
        placeholder="Enter Description..."
        onChange={handleChange}
      />
      <div className={styles.charCounter}>
        {charCount}/{maxLength} characters
      </div>
    </div>
  );
};

export default React.memo(QuillEditor);
